import React from 'react';

// Redux
import { useDispatch } from 'react-redux';

// Material UI
import { Grid, Box, Typography, Button } from '@material-ui/core';

// React Inline SVG
import SVG from 'react-inlinesvg';

// Actions
import { setClose } from 'store/ducks/dialogs/actions';

// Components
import { ModalTemplate } from 'components/ModalTemplate';

// Constants
import IMAGES from 'constants/images';

// Styles
import useStyles from './styles';

type Props = {
  title?: string;
  newTitle?: string;
  handleDelete: () => void;
};

const DeleteProductModal: React.FC<Props> = ({
  title,
  newTitle,
  handleDelete,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  return (
    <ModalTemplate
      classes={{
        container: classes.root,
      }}>
      <Grid container direction='column'>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Typography style={{ fontSize: '1.5rem', fontWeight: '700' }}>
            Excluir
          </Typography>
          <Typography component='h2'>
            {newTitle
              ? newTitle
              : `Deseja excluir a ${title} da lista de balsas da frota?`}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Grid container justifyContent='center' alignItems='center'>
            <Box className={classes.iconContainer}>
              <SVG src={IMAGES.LARGE_TRASH} title='Lixeira' />
            </Box>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Grid container justifyContent='flex-end' alignItems='center'>
            <Grid item>
              <Button
                className={[classes.cancelButton].join(' ')}
                onClick={() => dispatch(setClose({}))}>
                Cancelar
              </Button>
            </Grid>
            <Grid item>
              <Button className={classes.button} onClick={handleDelete}>
                Excluir
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </ModalTemplate>
  );
};

export default DeleteProductModal;
export { DeleteProductModal };
